import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  constructor() { }


  set(key: string, value: any) {
    localStorage.setItem(key, JSON.stringify(value));
  }


  get(key: string) {
    let token = localStorage.getItem(key)
    if (!token) {
      return null;
    }
    return JSON.parse(token);
  }


  clearAll() {
    const keysToRemove: string[] = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && !key.startsWith('ticketHistoryState_')) {
        keysToRemove.push(key);
      }
    }
    for (const key of keysToRemove) {
      localStorage.removeItem(key);
    }
  }

}
